export default function Services() {
  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Emagrecimento Personalizado',
      description: 'Programas individualizados com acompanhamento nutricional, tecnologias de ponta e suporte contínuo para alcançar seu peso ideal de forma saudável e sustentável.',
      image: 'https://public.readdy.ai/ai/img_res/734a38974a288f09fddd3fcff63edf4a.jpg'
    },
    {
      icon: 'ri-sparkling-line',
      title: 'Tratamentos Faciais',
      description: 'Rejuvenescimento facial com técnicas avançadas, limpeza profunda, hidratação intensiva e procedimentos anti-idade para uma pele radiante e saudável.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20facial%20treatment%20spa%20therapy%20with%20professional%20aesthetician%20warm%20earth%20tones%20beige%20brown%20colors%20elegant%20clean%20environment%20natural%20lighting%20sophisticated%20beauty%20care%20simple%20background%20serene%20atmosphere&width=600&height=400&seq=service-002&orientation=landscape'
    },
    {
      icon: 'ri-body-scan-line',
      title: 'Modelagem Corporal',
      description: 'Tecnologias não invasivas para redução de medidas, combate à celulite e flacidez, esculpindo o corpo dos seus sonhos com resultados visíveis e duradouros.',
      image: 'https://readdy.ai/api/search-image?query=body%20contouring%20treatment%20modern%20aesthetic%20clinic%20with%20advanced%20technology%20warm%20beige%20brown%20color%20palette%20clean%20minimalist%20design%20professional%20wellness%20space%20simple%20background%20elegant%20atmosphere&width=600&height=400&seq=service-003&orientation=landscape'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Drenagem Linfática',
      description: 'Técnica especializada para eliminar toxinas, reduzir retenção de líquidos e inchaços, promovendo bem-estar e leveza com toque terapêutico profissional.',
      image: 'https://readdy.ai/api/search-image?query=lymphatic%20drainage%20massage%20therapy%20spa%20treatment%20room%20with%20warm%20earth%20tones%20beige%20brown%20colors%20serene%20peaceful%20environment%20natural%20elements%20clean%20simple%20background%20professional%20wellness%20care&width=600&height=400&seq=service-004&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Depilação a Laser',
      description: 'Remoção definitiva de pelos com tecnologia laser de última geração, segura e eficaz para todos os tipos de pele, garantindo suavidade permanente.',
      image: 'https://readdy.ai/api/search-image?query=laser%20hair%20removal%20treatment%20modern%20aesthetic%20clinic%20with%20advanced%20equipment%20warm%20beige%20brown%20color%20scheme%20clean%20professional%20environment%20simple%20background%20sophisticated%20beauty%20technology&width=600&height=400&seq=service-005&orientation=landscape'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Tratamentos Capilares',
      description: 'Cuidados especializados para cabelos e couro cabeludo, incluindo hidratação profunda, reconstrução capilar e tratamentos anti-queda para fios fortes e brilhantes.',
      image: 'https://readdy.ai/api/search-image?query=professional%20hair%20treatment%20salon%20spa%20with%20warm%20earth%20tones%20beige%20brown%20colors%20elegant%20modern%20design%20natural%20lighting%20clean%20simple%20background%20luxury%20hair%20care%20service%20sophisticated%20atmosphere&width=600&height=400&seq=service-006&orientation=landscape'
    }
  ];

  return (
    <section id="servicos" className="py-32 bg-gradient-to-b from-white via-[#F8F6F4] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 bg-[#915726]/10 rounded-full mb-6">
            <span className="text-[#915726] text-sm font-semibold tracking-wider uppercase">Nossos Serviços</span>
          </div>
          <h2
            className="text-5xl md:text-6xl font-bold text-[#676028] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Tratamentos Exclusivos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Oferecemos uma gama completa de tratamentos estéticos e de emagrecimento com tecnologia de ponta
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-6 left-6 w-14 h-14 flex items-center justify-center bg-white rounded-2xl shadow-lg group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-2xl text-[#915726]`}></i>
                </div>
              </div>
              <div className="p-8">
                <h3
                  className="text-2xl font-bold text-[#676028] mb-4 group-hover:text-[#915726] transition-colors"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}